import React from "react";

function ShipmentCloneFrequency({frequencies}) {
 
  return (
    <>
      <div
        className="font-face-vzw py-1"
        style={{
          fontWeight: 700,
          fontSize: "20px",
          color: "#6F7171"
        }}
      >
        Frequency
      </div>
      
      <div className="py-2 w-100 d-flex flex-row justify-content-start align-items-center">
        <div className="w-50 d-flex flex-column justify-content-center align-items-start">
          <span className="d-flex flex-row justify-content-start align-items-center font-face-vzw shipment-clone-font-size">Reporting Frequency</span>
           <p>{frequencies?.capturesensorvalues}</p>
        </div>
        <div className="w-50 d-flex flex-column justify-content-center align-items-start">
          <span className="d-flex flex-row justify-content-start align-items-center font-face-vzw shipment-clone-font-size">Monitoring Frequency</span>
          <p>{frequencies?.sensordatafrequency}</p>
        </div>
      </div>
    </>
  );
}

export default ShipmentCloneFrequency;
